import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { Tier } from '../../enums/tier.enum';
import { IdName } from '../../models/id-name.model';

@Pipe({
  name: 'maxActiveProgramNumber',
  standalone: false
})
export class MaxActiveProgramNumberPipe implements PipeTransform {
  public transform(value: Tier): string {
    return getMaxActiveProgramNumber(value);
  }
}

export function getMaxActiveProgramNumber(value: Tier): string {
  switch (value) {
    case Tier.Basic:
      return '1';
    case Tier.Professional:
      return '5';
    case Tier.Enterprise:
      return null;
    default:
      throw new Error(`Unsupported value for Tier: ${value}.`);
  }
}

export function getMaxActiveProgramNumberList(): IdName[] {
  return enumToList(Tier, getMaxActiveProgramNumber);
}
